import { v4 as uuid } from 'uuid';

import { ThreatMatrixSettings } from '@mono/types/src/weather-widgets/threat-matrix';

export const defaultSettings: ThreatMatrixSettings = {
    title: 'Threat Matrix',
    fontSize: 100,
    rows: [
        {
            capabilityId: '',
            datasetId: '',
            label: 'Row 1',
            id: uuid(),
            space: {
                lat: -40,
                lon: 173,
            },
            thresholdOperator: 'greaterThan',
            warningThreshold: 0,
            alertThreshold: 0,
            icon: 'cloud',
        },
    ],
    mode: 'cozy',
    theme: 'light',
    timeRange: 'P0D--P1D',
    canDownload: false,
};
